import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Axios from 'axios';
import Compressor from 'compressorjs';

import { BackDropLoad } from './LoadingBackDrop';
import { Loading } from './Loading';
import { UserContext, SnackbarContext } from './userContext';
import { AutoCompLoc } from './AutoCompLoc.jsx';
import {
  AccountHeader,
  FormCard,
  Field,
  SelectField,
  PrimaryButton,
  GhostButton,
  Modal,
  Icon,
} from './myacc/primitives';

export const MyAccAddPro = () => {
  const history = useNavigate();

  const [loading, setLoading] = useState(true);

  const [subcats, setSubcats] = useState();
  const [subcat, setSubcat] = useState('0');

  const [images, setImages] = useState([]);

  const [pname, setPname] = useState('');
  const [email, setEmail] = useState('');
  const [mob, setMob] = useState('');
  const [loc, setLoc] = useState('');
  const [shortdesc, setShortdesc] = useState('');
  const [longdesc, setLongdesc] = useState('');

  const [showAlert, setShowAlert] = useState(true);
  const [error, setError] = useState(0);

  const [wait, setWait] = useState(false);
  const [uploadwait] = useState(false);

  const { user, setUser } = useContext(UserContext);
  const { setSnack } = useContext(SnackbarContext);

  useEffect(() => { getData(); }, []); // eslint-disable-line

  const updateLoc = (l) => setLoc(l);

  const compImage = (image) => new Promise((resolve) => {
    new Compressor(image, {
      quality: 0.8,
      success: (compressedResult) => resolve(compressedResult),
    });
  });

  const getData = () => {
    const formData = { role: user.user_role, cat: user.category_ids, uid: user.user_id };
    Axios.post('/new_apis/getprodsubcats', formData, { headers: { tkn: user.token } }).then((res) => {
      if (res.data.status === 1) {
        setSubcats(res.data.subcats);
        setLoading(false);
      } else if (res.data.status === 2) {
        setSnack({ message: res.data.msg, type: 'warning', open: true, direction: 'left' });
      } else if (res.data.status === 3) {
        setSnack({ message: res.data.msg, type: 'warning', open: true, direction: 'left' });
        history('/');
      } else if (res.data.status === 4) {
        setUser(null);
        history('/');
        localStorage.removeItem('estkn');
        setSnack({ message: res.data.msg, type: 'warning', open: true, direction: 'left' });
      }
    });
  };

  const addDetails = (e) => {
    e.preventDefault();
    setError(0);
    if (pname === '') { setError(1); setSnack({ message: 'Please enter the product / service name.', type: 'error', open: true, direction: 'center' }); return; }
    if (subcat === '0') { setError(2); setSnack({ message: 'Please select the sub-category.', type: 'error', open: true, direction: 'center' }); return; }
    if (mob.length !== 10) { setError(3); setSnack({ message: 'Please enter a valid 10-digit mobile number.', type: 'error', open: true, direction: 'center' }); return; }
    if (shortdesc === '') { setError(4); setSnack({ message: 'Please enter a short description.', type: 'error', open: true, direction: 'center' }); return; }
    if (loc === '') { setError(5); setSnack({ message: 'Please enter the location.', type: 'error', open: true, direction: 'center' }); return; }
    if (longdesc === '') { setError(6); setSnack({ message: 'Please enter a long description.', type: 'error', open: true, direction: 'center' }); return; }
    if (images.length === 0) { setError(7); setSnack({ message: 'Please choose at least one image.', type: 'error', open: true, direction: 'center' }); return; }

    setWait(true);
    const formData = new FormData();
    formData.append('uid', user.user_id);
    formData.append('role', user.user_role);
    formData.append('cat', user.category_ids);
    formData.append('subcat', subcat);
    formData.append('pname', pname);
    formData.append('email', email);
    formData.append('mob', mob);
    formData.append('sdesc', shortdesc);
    formData.append('ldesc', longdesc);
    formData.append('loc', loc);
    for (let i = 0; i < images.length; i += 1) formData.append('images', images[i].raw);

    Axios.post('/new_apis/addproduct', formData, { headers: { tkn: user.token } }).then((res) => {
      if (res.data.status === 1) {
        setWait(false);
        history('/myaccount/my_prods_servs');
        setSnack({ message: res.data.msg, type: 'success', open: true, direction: 'center' });
      } else if (res.data.status === 2) {
        setWait(false);
        setSnack({ message: res.data.msg, type: 'error', open: true, direction: 'center' });
        if (res.data.field === 1) setError(1);
        else if (res.data.field === 2) setError(4);
        else if (res.data.field === 3) setError(6);
        else if (res.data.field === 4) setError(8);
      } else if (res.data.status === 3) {
        setWait(false);
        history('/');
        setSnack({ message: res.data.msg, type: 'error', open: true, direction: 'center' });
      } else if (res.data.status === 4) {
        setUser(null);
        setWait(false);
        localStorage.removeItem('estkn');
        history('/');
        setSnack({ message: res.data.msg, type: 'warning', open: true, direction: 'center' });
      }
    });
  };

  const onUpload = async (e) => {
    if (e.target.files.length === 0) return;
    if (images.length + e.target.files.length > 3) {
      alert('Maximum image limit is 3.');
      e.target.value = '';
      return;
    }
    const arr = [];
    for (let i = 0; i < e.target.files.length; i += 1) {
      const t = e.target.files[i].type;
      if (t === 'image/jpeg' || t === 'image/jpg' || t === 'image/png') {
        const img = await compImage(e.target.files[i]);
        arr.push({ raw: img, preview: URL.createObjectURL(img) });
      } else {
        alert('Please select only JPEG, JPG, or PNG images.');
      }
    }
    setImages([...images, ...arr]);
    e.target.value = '';
  };

  if (loading) return <Loading />;

  return (
    <>
      <BackDropLoad wait={wait} />

      <Modal
        open={showAlert}
        onClose={() => setShowAlert(false)}
        title="Important note"
        size="sm"
        footer={<PrimaryButton onClick={() => setShowAlert(false)}>Okay, I agree</PrimaryButton>}
      >
        Please note that the title, images, and descriptions provided must not contain contact details
        (emails, contact numbers, locations, etc.). If found, they will be altered or rejected.
      </Modal>

      <AccountHeader
        kicker="Account"
        title="Add product / service"
        subtitle="List a new offering for customers to find on ESAY."
      />

      <FormCard onSubmit={addDetails}>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
          <Field
            label="Product / service name"
            value={pname}
            onChange={(e) => setPname(e.target.value)}
            error={error === 1}
            errorMsg="Please enter a name."
            required
          />

          <SelectField
            label={`Sub-category in ${user.cat_name}`}
            value={subcat}
            onChange={(e) => setSubcat(e.target.value)}
            error={error === 2}
            errorMsg="Please choose a sub-category."
            required
          >
            <option value="0">Please select a sub-category</option>
            {subcats && subcats.map((sc) => (
              <option key={sc.sub_category_id} value={sc.sub_category_id}>{sc.sub_category_name}</option>
            ))}
          </SelectField>

          <Field
            label="Email ID (optional)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            icon={<Icon.Mail className="h-4 w-4" />}
          />

          <Field
            label="Mobile number"
            type="number"
            value={mob}
            onChange={(e) => setMob(e.target.value)}
            error={error === 3}
            errorMsg="Please enter a valid 10-digit mobile number."
            required
            inputMode="numeric"
            maxLength={10}
            icon={<Icon.Phone className="h-4 w-4" />}
          />

          <Field
            label="Short description"
            value={shortdesc}
            onChange={(e) => setShortdesc(e.target.value)}
            error={error === 4}
            errorMsg="Please enter a short description."
            required
          />

          <div>
            <label className="mb-1.5 block text-[10.5px] font-bold uppercase tracking-[0.14em] text-fg-tertiary">
              Location <span className="ml-1 text-amber">*</span>
            </label>
            <AutoCompLoc compact error={error === 5} loc={loc} setloc={updateLoc} label="Where" required={false} />
            {error === 5 && (
              <div className="mt-1.5 text-[11px] text-red-400">Please select your location.</div>
            )}
          </div>

          <div className="sm:col-span-2">
            <Field
              label="Long description"
              multiline
              rows={6}
              value={longdesc}
              onChange={(e) => setLongdesc(e.target.value)}
              error={error === 6}
              errorMsg="Please enter a long description."
              required
            />
          </div>

          {/* Images */}
          <div className="sm:col-span-2">
            <label className="mb-1.5 block text-[10.5px] font-bold uppercase tracking-[0.14em] text-fg-tertiary">
              Images <span className="ml-1 text-amber">*</span>
            </label>
            <div className="flex flex-wrap items-center gap-3">
              <label
                htmlFor="add-prod-file"
                className="
                  inline-flex h-11 items-center gap-1.5 rounded-lg px-4 cursor-pointer
                  text-[11.5px] font-bold uppercase tracking-[0.1em]
                  border border-amber/40 bg-amber/10 text-amber
                  transition-[background-color,border-color] duration-200
                  hover:bg-amber/20 hover:border-amber/60
                "
              >
                <Icon.Upload className="h-4 w-4" />
                Upload images
              </label>
              <input
                id="add-prod-file"
                type="file"
                accept="image/*,capture=camera"
                capture="camera"
                multiple
                hidden
                onChange={onUpload}
              />
              <span className="text-[11px] text-fg-tertiary">{images.length}/3 selected · JPG, PNG</span>
            </div>
            {error === 7 && (
              <div className="mt-1.5 text-[11px] text-red-400">Please choose at least one image.</div>
            )}
            {error === 8 && (
              <div className="mt-1.5 text-[11px] text-red-400">Ensure the images uploaded do not contain any contact information.</div>
            )}

            {uploadwait && (
              <div className="mt-3 text-[12px] text-fg-tertiary">Adding images…</div>
            )}

            {images.length !== 0 && (
              <div className="mt-3 grid grid-cols-2 sm:grid-cols-3 gap-3">
                {images.map((image) => (
                  <div
                    key={image.preview}
                    className="relative overflow-hidden rounded-xl border border-border-subtle bg-surface-overlay"
                  >
                    <div className="aspect-square">
                      <img src={image.preview} alt="" className="h-full w-full object-cover" />
                    </div>
                    <button
                      type="button"
                      onClick={() => setImages(images.filter((it) => it.preview !== image.preview))}
                      aria-label="Remove image"
                      className="
                        absolute top-1.5 right-1.5
                        inline-flex h-7 w-7 items-center justify-center rounded-full
                        bg-black/70 backdrop-blur-md text-fg-primary
                        transition-[background-color,color] duration-200
                        hover:bg-red-400 hover:text-ink
                      "
                    >
                      <Icon.Close className="h-3.5 w-3.5" />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="sm:col-span-2 pt-1 flex flex-wrap items-center gap-2">
            <PrimaryButton type="submit" loading={wait} icon={<Icon.Add className="h-4 w-4" />}>
              {wait ? 'Please wait…' : 'Add details'}
            </PrimaryButton>
            <GhostButton onClick={() => history('/myaccount/my_prods_servs')}>
              Cancel
            </GhostButton>
          </div>
        </div>
      </FormCard>
    </>
  );
};
